import type { Precision } from './types';

const fractionDigitsByPrecision: Record<Precision, number> = {
  low: 0,
  medium: 1,
  high: 2,
};

export function getFractionDigits(precision: Precision = 'medium') {
  return fractionDigitsByPrecision[precision];
}
